import * as BABYLON from 'babylonjs';
import VisualComponent from './VisualComponent';
class Transition extends VisualComponent {
    getType() { return "Transition"; }

    constructor( { id } = {} ) {
        super( { id });
    }

    construct( context, prefab ) {
        let situation;
        for (let i = 0; i < context.situations.length; i++) 
            if(context.situations[i].id == prefab.getTargetID())
                situation = context.situations[i];
        

        super.setScaleFactor(0.2);
        const base = super.construct( context, prefab );

        var ease = new BABYLON.CubicEase();
        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEIN);
        
        this.mesh.actionManager = new BABYLON.ActionManager(this.scene);
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger,() => {
            if(!context.followModeratorMode){
                window.dispatchEvent(new CustomEvent("hideTransitionPreview"));
                context.$store.commit('handleGotoSituationTransition',{ situationID: prefab.getTargetID() }); 

                // TODO: Fix Transition Animation
                // Camera Rotation & Animation when leaving current room
                // let camera = window.scene.activeCamera;
                // let fps = 60;
                // let duration = 1000;

                // var clickedMeshPos = base.position;
                // let unitVec = new BABYLON.Vector3(clickedMeshPos.x,0,clickedMeshPos.z).normalize();
                // var transitionEndPoint = camera.target.add(unitVec.scale(120));

                // var coordinates = BABYLON.Vector3.Project(
                //     clickedMeshPos,
                //     BABYLON.Matrix.Identity(),
                //     window.scene.getTransformMatrix(),
                //     camera.viewport.toGlobal(
                //     window.scene.getEngine().getRenderWidth(),
                //     window.scene.getEngine().getRenderHeight(),
                // ));
                // var vec_target_n = new BABYLON.Vector3(clickedMeshPos.x, 0 ,clickedMeshPos.z);
                // var vec_camDirection_n = camera.getForwardRay().direction;
                // vec_camDirection_n.y = 0;
                // var dotProduct = vec_target_n.x*vec_camDirection_n.x + vec_target_n.y*vec_camDirection_n.y + vec_target_n.z*vec_camDirection_n.z;
                // var newAngle = Math.acos(dotProduct/(vec_target_n.length()*vec_camDirection_n.length()));
                // var newCamAlpha = coordinates.x > (this.scene.getEngine().getRenderWidth()/2) ? camera.alpha-newAngle : camera.alpha+newAngle

                // setTimeout(() => {
                //     document.getElementById("renderCanvas").style.filter = "blur(20px)";
                //     setTimeout(() => {
                //         document.getElementById("renderCanvas").style.filter = "blur(0px)";
                //     }, 400);
                // }, duration-300);
                // 
                // BABYLON.Animation.CreateAndStartAnimation("",camera,"alpha",fps, (duration/1000)*fps, camera.alpha, newCamAlpha, 0, ease);
                // BABYLON.Animation.CreateAndStartAnimation("",camera,"target",fps, (duration/1000)*fps, camera.target, transitionEndPoint, 0, ease);
                // BABYLON.Animation.CreateAndStartAnimation("",camera,"beta",fps, (duration/1000)*fps, camera.beta, camera.beta, 0, ease, () => {
                //     context.$store.commit('handleGotoSituationTransition',{ situationID: prefab.getTargetID() }); 
                // });
            }
        }));
        
        // Hover-over animation
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger,() => {   
            // BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 30,10, this.mesh.scaling, new BABYLON.Vector3.One(), 0, ease);  
            window.dispatchEvent(new CustomEvent("hideTransitionPreview"));
        }));

        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger,() => {
            // BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 30,10, this.mesh.scaling, new BABYLON.Vector3.One().scale(1.1), 0, ease);
            window.dispatchEvent(new CustomEvent("showTransitionPreview",{detail:{
                url: context.publicPath + "/media" + context.$store.getters.mediaURL + "/" + situation.name.trim() + "." + context.thumbnailType,
                name: situation.name,
            }}));
        }));

        var ease2 = new BABYLON.CubicEase();
        ease2.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
        
        // Pulse Animation
        const frameRate = 60;
        const pulse = new BABYLON.Animation("pulse", "scaling", frameRate, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
        pulse.setEasingFunction(ease2);
        const keyFrames = []; 
        keyFrames.push({frame: 0, value: new BABYLON.Vector3(1,1,1)});
        keyFrames.push({frame: 2* frameRate, value: new BABYLON.Vector3(1.2,1.2,1.2)});
        keyFrames.push({frame: 4 * frameRate, value: new BABYLON.Vector3(1,1,1)});
        pulse.setKeys(keyFrames);
        this.mesh.animations.push(pulse);
        window.scene.beginAnimation(this.mesh, 0, 10 * frameRate, true);

        return base;
    }
}

export default Transition;
